/* eslint-disable */
import React from 'react';
import PropTypes from 'prop-types';

// components
import {
  Grid,
  FormControl,
  Select,
  MenuItem,
  FormHelperText,
  IconButton,
} from '@mui/material';

// icons
import CloseRounded from '@mui/icons-material/CloseRounded';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import InputLabel from '../inputLabel';

// utils
import { noop } from '../../utils/general';
import { useTranslation } from 'react-i18next';

function LoginSelectField({ label, error, onChange, value, id, styles, options }) {
  const { t } = useTranslation()
  return (
    <Grid item>
      <FormControl sx={styles}>

        <InputLabel label={label} />
        <Select
          id={id}
          key={value}
          value={value}
          onChange={onChange}
          IconComponent={KeyboardArrowDownIcon}
          sx={{
            height: '37px',
            border: '1.4px solid #000',
            borderRadius: '5px',
            width: '87%',
            fontSize: '13px',
            '& .MuiOutlinedInput-notchedOutline': {
            border: 'none',
            },
            '&.Mui-focused': {
            border: '2px solid #3498db',
            },
            '& .MuiSelect-icon': {
              color: 'rgb(0, 0, 0, 0.87)',
              fontSize: '20px',
            },

          }}

          endAdornment={
            value && (
              <IconButton
                size="small"
                onClick={() => onChange(null)}
                onMouseDown={(event) => {
                  event.stopPropagation();
                }}
                style={{ margin: '0px', width: 'auto' }}
              >
                <CloseRounded sx={{ fontSize: '20px', color: 'rgb(0, 0, 0, 0.87)' }} />
              </IconButton>
            )
          }
          displayEmpty
          renderValue={(value) => {
            if (!value) return t('login-select')
            const selectedOption = options.find((option) => option.value === value);
            return selectedOption ? selectedOption.label : '';
          }}
        >
          {options.map((option) => (
            <MenuItem sx={{ fontSize: '13px' }} key={option?.value} value={option?.value}>
              {option?.label}
            </MenuItem>
          ))}
        </Select>
        <FormHelperText>{error}</FormHelperText>
      </FormControl>
    </Grid>
  );
}

LoginSelectField.propTypes = {
  error: PropTypes.string,
  onChange: PropTypes.func,
  styles: PropTypes.object,
  options: PropTypes.array,
  value: PropTypes.string,
};

LoginSelectField.defaultProps = {
  error: undefined,
  onChange: noop,
  styles: { width: '400px', marginTop: '20px' },
  options: [],
  value: undefined,
};

export default LoginSelectField;
